import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-chevron-up.tsx
/**
* icon.24.chevron.up
*
* Keywords: caret, upward, navigation, pointer, expand, arrow, triangle, pointing
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTExLjcyNSAxMC4wODJhLjUuNSAwIDAgMSAuNjI5LjA2NGwyLjUgMi41YS41LjUgMCAwIDEtLjcwNy43MDdMMTIgMTEuMjA3bC0yLjE0NiAyLjE0NmEuNS41IDAgMSAxLS43MDgtLjcwN2wyLjUtMi41eiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-663
*/
const Icon24ChevronUp = memo(function Icon24ChevronUp(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M11.725 10.082a.5.5 0 0 1 .629.064l2.5 2.5a.5.5 0 0 1-.707.707L12 11.207l-2.146 2.146a.5.5 0 1 1-.708-.707l2.5-2.5z"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M11.225 10.082a.5.5 0 0 1 .629.064l2.5 2.5a.5.5 0 0 1-.707.707L11.5 11.207l-2.146 2.146a.5.5 0 1 1-.708-.707l2.5-2.5z"
		})
	});
});
//#endregion
export { Icon24ChevronUp };

//# sourceMappingURL=icon-24-chevron-up.js.map